import { cn } from "@/lib/utils";
import { getGroupColor } from "@/lib/thread-groups";

/**
 * Compact group pill on a thread row: a neutral muted surface where only the dot carries the
 * group's color — identity without shouting (same calm treatment as the header tag chips).
 * The full group definition (id, name, colorId) is required.
 */
export function ThreadGroupChip({ group, className }) {
  if (!group) return null;
  const color = getGroupColor(group.colorId);
  return (
    <span
      className={cn(
        "inline-flex h-4 max-w-[10rem] shrink-0 items-center gap-1 rounded border border-border/70 bg-muted/40 px-1.5 text-[10px] font-medium leading-none text-foreground/75",
        className,
      )}
      title={group.name}
    >
      <span className={cn("h-1.5 w-1.5 shrink-0 rounded-full", color.dotClassName)} />
      <span className="truncate">{group.name}</span>
    </span>
  );
}
